import { CREATE_ORDER } from 'api/graphql/orders';
import * as Order from '../model/Order';
import { parseShape } from '../model/utils';
import Model from '../model';
import { sanitize } from './utils';

const types = {
    event: String,
    comment: String,
    customerPhone: String,
    customerBirthday: String,
    customerName: String,
    customerSurname: String,
    customerSex: String,
    customerEmail: String,
    customerSkype: String,
    saleSum: Number,
    pairVisit: Boolean,
    system: String
}

export const createOrder = async (variables) => {
    return Model.apollo.mutate({
        mutation: CREATE_ORDER,
        variables: sanitize(variables, types)
    }).then((response) => {
        const data = parseShape(response['data']);
        if (data?.['createOrder']?.['order'] === undefined) {
            return {
                error: data?.['createOrder']?.['error'] || `no valid response from server, received: ${ response }`
            }
        }
        const paymentStatus = data?.['createOrder']?.['order']?.['payment']?.['status'];
        const alfa = data?.['createOrder']?.['order']?.['payment']?.['alfa'];
        const yandex = data?.['createOrder']?.['order']?.['payment']?.['yandex']
        const payUrl = alfa?.['payUrl'] || yandex?.['payUrl'];

        const order = Order.createOrder(response['data']?.['createOrder']?.['order']);

        return {
            response: response['data']?.['createOrder']?.['order'],
            order,
            payUrl,
            paymentStatus,
            error: response['data']?.['createOrder']?.['error']
        }
    });
}

export const payOrder = ({ orderId, service }) => {
    let url = '/order/pay_order';
    const formData = new FormData();
    formData.append('order_id', orderId);
    return fetch(url, {
        method: 'POST',
        body: formData
    }).then((promise) => {
        return promise.json();
    }).then((response) => {
        let errorMessage = '';
        const error = response?.error;
        if (error === 'paid')
            errorMessage = 'Заказ уже оплачен';
        else if (error === 'too_late')
            errorMessage = `Вы пытаетесь изменить запись менее чем за ${service === 'OFF' ? '24 часа' : '12 часов'} до ее начала, а это невозможно`;
        else {
            errorMessage = `Произошла неизвестная ошибка, обратитесь к администратору`;
        }
        return {
            response,
            redirect: response?.redirect,
            error: response?.error,
            errorMessage
        };
    });
}
